<template>
  <div
    class="toggle-radio-card-parts"
    :class="{ 'toggle-radio-card-parts--selected': currentValue === radioValue }"
    @click="handlerOnClick(radioValue)"
  >
    <atom-input-radio class="toggle-radio-card-parts__radio" :value="currentValue === radioValue" />
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import AtomInputRadio from '@/components/atoms/input/AtomInputRadio.vue'
import { PlanGroupType } from '@/store/stores/collectionModule/documents/plan/ContractPlanDocument'

/**
 * ラジオ選択カード セクション
 */
export default defineComponent({
  name: 'ToggleRadioCardParts',
  components: {
    AtomInputRadio,
  },
  props: {
    /**
     * 選択中のvalue値
     */
    currentValue: {
      type: String as PropType<PlanGroupType>,
      required: true,
    },
    /**
     * ラヂオのvalue値
     */
    radioValue: {
      type: String as PropType<PlanGroupType>,
      required: true,
    },
  },
  setup(props, context) {
    const handlerOnClick = (val: string) => context.emit('handlerOnClick', val)

    return {
      handlerOnClick,
    }
  },
})
</script>

<style lang="scss" scoped>
.toggle-radio-card-parts {
  position: relative;
  width: 100%;
  max-width: 768px;
  padding: 8px 10px 10px 37px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  cursor: pointer;

  @media screen and (min-width: $responsiveTabletWidth) {
    padding: 10px 10px 10px 40px;
  }

  &--selected {
    background: rgba(0, 219, 166, 0.3);
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  &__radio {
    position: absolute;
    top: 9px;
    left: 9px;
    pointer-events: none;

    @media screen and (min-width: $responsiveTabletWidth) {
      top: 11px;
      left: 11px;
    }
  }
}
</style>
